export function dollarsToCents(dollars: number) {
	return Math.round(dollars * 100);
}

export function centsToDollars(cents: number) {
	return cents / 100;
}
